export default "__VITE_ASSET__DWm5dwaq__"